class Search {
  constructor(element) {
    this.element = element;
    this.init();
  }
  init() {
    this.input = this.element.querySelector('input');
    this.button = this.element.querySelector('button');
    if (this.input) {
      // 监听input事件并添加防抖
      this.input.addEventListener('input', this.debounce(this.handleChange.bind(this), 300));
      // 监听focus
      this.input.addEventListener('focus', this.handleFocus.bind(this));
    }
    if (this.button) {
      this.button.addEventListener('click', this.clickSearch.bind(this));
    }
    this.element.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
    });
    this.element.querySelector('#clear-btn').addEventListener('click', () => {
      this.element.querySelector('input').value = '';
      this.element.querySelector('input').setAttribute('data-has-value', 'false');
      this.element.dispatchEvent(new CustomEvent('search', { detail: '' }));
    });
  }
  handleFocus(event) {
    // 触发事件
    this.element.dispatchEvent(new CustomEvent('focus', { detail: event.target.value }));
  }
  handleChange(event) {
    if (event.target.value.trim() !== '') {
      this.element.querySelector('input').setAttribute('data-has-value', 'true');
    } else {
      this.element.querySelector('input').setAttribute('data-has-value', 'false');
    }
    // 触发事件
    this.element.dispatchEvent(new CustomEvent('search', { detail: event.target.value }));
  }
  debounce(fn, delay) {
    let timer = null;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, arguments), delay);
    };
  }
  clickSearch() {
    if (this.element.querySelector('input').value.trim() === '') {
      this.element.querySelector('input').focus();
      window.litime.showToast('warning', window.i18n.please_input_search_keyword);
      return;
    }
    this.element.dispatchEvent(new CustomEvent('clickSearch', { detail: this.element.querySelector('input').value }));
  }
}
$(function () {
  // 在这里编写需要在文档加载完成后执行的代码
  if (!customElements.get('sale-support-banner')) {
    customElements.define(
      'sale-support-banner',
      class SaleSupportBanner extends HTMLElement {
        keyword = '';
        mobileKeyword = '';
        firstLoad = true;
        constructor() {
          super();
        }

        connectedCallback() {
          this.init();
          this.initMobile();
        }

        async fetchSearchData(keyword) {
          const res = await window.litime.http.get(
            `/shopify/support-center/search`,
            {
              data: {
                query: keyword,
              },
            },
            'business-api'
          );
          if (res.code === 200) {
            return res.data;
          } else {
            throw new Error(res.message);
          }
        }

        init() {
          const inputWrapper = this.querySelector(
            '.sale-support-banner__search__container .sale-support-search__container'
          );
          const search = new Search(inputWrapper);
          // 监听search事件
          search.element.addEventListener('search', async (event) => {
            event.preventDefault();
            event.stopPropagation();
            const contain = this.querySelector('.result-list-container');
            this.keyword = event.detail;
            if (this.keyword.trim() === '') {
              contain.classList.add('hidden');
              return;
            }
            this.searchEvent(event, contain);
          });
          // 监听clickSearch事件
          search.element.addEventListener('clickSearch', (event) => {
            const url = inputWrapper.querySelector('button').getAttribute('data-url');
            if (url) {
              this.jumpSearchResult(url, 'all', event.detail);
            }
          });
          // 监听focus事件
          search.element.addEventListener('focus', (event) => {
            if (this.firstLoad) {
              this.firstLoad = false;
              const contain = this.querySelector('.result-list-container');
              this.keyword = event.detail;
              if (this.keyword.trim() === '') {
                contain.classList.add('hidden');
                return;
              }
              this.searchEvent(event, contain);
              return;
            }
            if (this.keyword.trim()) {
              const contain = this.querySelector('.result-list-container');
              contain.classList.remove('hidden');
            }
          });

          window.addEventListener('click', (event) => {
            if (window.innerWidth > 576) {
              this.closeSearchPopup();
            }
          });

          const keyword = this.querySelectorAll('.sale-support-banner__keyword');
          keyword.forEach((item) => {
            item.addEventListener('click', (event) => {
              event.preventDefault();
              event.stopPropagation();
              const url = inputWrapper.querySelector('button').getAttribute('data-url');
              if (url) {
                this.jumpSearchResult(url, 'all', item.textContent.trim());
              }

              // inputWrapper.querySelector('input').value = item.textContent.trim();
              // // 手动触发 input 事件
              // inputWrapper
              //   .querySelector('input')
              //   .dispatchEvent(new Event('input', { detail: item.textContent.trim() }));
            });
          });
          const contain = this.querySelector('.result-list-container');
          const highlight = contain.querySelectorAll('.highlight');
          highlight.forEach((item) => {
            item.addEventListener('click', () => {
              window.litime.openChatApp();
            });
          });
        }

        jumpSearchResult(url, type, keyword) {
          const params = new URLSearchParams();
          params.set('type', type);
          params.set('keyword', keyword);
          window.location.href = `${url}?${params.toString()}`;
        }

        async searchEvent(event, contain) {
          contain.classList.remove('hidden');
          this.showLoading(contain);
          const data = await this.fetchSearchData(event.detail);
          const wrapper = contain.querySelector('.result-list-container__wrapper');
          wrapper.innerHTML = '';
          if (data.products.length > 0) {
            const productList = this.renderProductList(data.products, contain);
            wrapper.innerHTML += productList;
          }
          if (data.blogs.length > 0) {
            const blogList = this.renderBlogList(data.blogs, contain);
            wrapper.innerHTML += blogList;
          }
          if (data.manuals.length > 0) {
            const manualList = this.renderMunualList(data.manuals, contain);
            wrapper.innerHTML += manualList;
          }
          this.hideLoading(contain);
          const resultEmpty = contain.querySelector('.result-empty');
          if (data.products.length === 0 && data.blogs.length === 0 && data.manuals.length === 0) {
            resultEmpty.classList.remove('hidden');
          } else {
            resultEmpty.classList.add('hidden');
          }
        }

        initMobile() {
          const inputWrapper = this.querySelector(
            '.sale-support-banner__mobile__search .sale-support-search__container'
          );
          const search = new Search(inputWrapper);
          search.element.addEventListener('search', async (event) => {
            event.preventDefault();
            event.stopPropagation();
            const contain = this.querySelector('.result-list-container__mobile');
            this.mobileKeyword = event.detail;
            if (this.mobileKeyword.trim() === '') {
              contain.classList.add('hidden');
              return;
            }
            this.searchEvent(event, contain);
          });

          search.element.addEventListener('clickSearch', (event) => {
            const url = inputWrapper.querySelector('button').getAttribute('data-url');
            if (url) {
              this.jumpSearchResult(url, 'all', event.detail);
            }
          });
          search.element.addEventListener('focus', (event) => {
            const contain = this.querySelector('.result-list-container__mobile');
            const searchContainer = this.querySelector('.sale-support-banner__mobile');
            if (window.innerWidth < 576) {
              searchContainer.classList.add('sale-support-banner__mobile__active');
              window.litime.disableScroll();
            }
            if (this.firstLoad) {
              this.firstLoad = false;
              this.mobileKeyword = event.detail;
              if (this.mobileKeyword.trim() === '') {
                contain.classList.add('hidden');
                return;
              }
              this.searchEvent(event, contain);
              return;
            }
            if (this.mobileKeyword.trim()) {
              const contain = this.querySelector('.result-list-container__mobile');
              contain.classList.remove('hidden');
            }
          });

          const keyword = this.querySelectorAll('.sale-support-banner__keyword__mobile');
          keyword.forEach((item) => {
            item.addEventListener('click', (event) => {
              event.preventDefault();
              event.stopPropagation();
              const url = inputWrapper.querySelector('button').getAttribute('data-url');
              if (url) {
                this.jumpSearchResult(url, 'all', item.textContent.trim());
              }
              // inputWrapper.querySelector('input').value = item.textContent.trim();
              //   const searchContainer = this.querySelector('.sale-support-banner__mobile');
              //   if (window.innerWidth < 576) {
              //     searchContainer.classList.add('sale-support-banner__mobile__active');
              //     window.litime.disableScroll();
              //   }
              //   // 手动触发 input 事件
              //   inputWrapper
              //     .querySelector('input')
              //     .dispatchEvent(new Event('input', { detail: item.textContent.trim() }));
            });
          });

          const back = this.querySelector('.sale-support-banner__back');
          back.addEventListener('click', () => {
            const searchContainer = this.querySelector('.sale-support-banner__mobile');
            searchContainer.classList.remove('sale-support-banner__mobile__active');
            this.closeSearchPopup();
            window.litime.enableScroll();
          });

          const contain = this.querySelector('.result-list-container__mobile');
          const highlight = contain.querySelectorAll('.highlight');
          highlight.forEach((item) => {
            item.addEventListener('click', () => {
              if (window.innerWidth < 576) {
                const searchContainer = this.querySelector('.sale-support-banner__mobile');
                searchContainer.classList.remove('sale-support-banner__mobile__active');
                this.closeSearchPopup();
              }
              window.litime.openChatApp();
            });
          });
        }

        closeSearchPopup() {
          const contain = this.querySelector('.result-list-container');
          contain.classList.add('hidden');
          const mobileContain = this.querySelector('.result-list-container__mobile');
          mobileContain.classList.add('hidden');
        }

        showLoading(contain) {
          const loading = $(contain.querySelector('.loading-container'));
          $(contain).find('.result-list-container__wrapper').addClass('hidden');
          $(contain).find('.result-empty').addClass('hidden');
          loading.removeClass('hidden').addClass('flex');
        }

        hideLoading(contain) {
          const loading = $(contain.querySelector('.loading-container'));
          $(contain).find('.result-list-container__wrapper').removeClass('hidden');
          $(contain).find('.result-empty').removeClass('hidden');
          loading.addClass('hidden').removeClass('flex');
        }
        // 添加高亮方法
        highlightText(text, keyword) {
          if (!keyword || keyword.trim() === '') {
            return text;
          }

          const regex = new RegExp(this.escapeRegExp(keyword), 'gi');
          return text.replace(regex, `<span class="active">$&</span>`);
        }

        // 正则匹配
        escapeRegExp(string) {
          return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        }

        // 渲染产品列表
        renderProductList(data, element) {
          let keyword = '';
          if (window.innerWidth <= 1200) {
            keyword = this.mobileKeyword.trim();
          } else {
            keyword = this.keyword.trim();
          }
          const title = element.getAttribute('data-product-name');
          const resultList = `<div class="result-list-item">
            <div class="result-list-item__title">${title}</div>
            <div class="result-list-item__content">
            ${data
              .map((item) => {
                return `<div data-type="product" class="result-list-item__content-item" onclick="window.location.href='/products/${
                  item.handle
                }'">
                ${this.highlightText(item.title, keyword)}</div>`;
              })
              .join('')}
            </div>
            </div>`;
          return resultList;
        }
        // 渲染博客列表
        renderBlogList(data, element) {
          let keyword = '';
          if (window.innerWidth <= 1200) {
            keyword = this.mobileKeyword.trim();
          } else {
            keyword = this.keyword.trim();
          }
          const title = element.getAttribute('data-blog-name');
          const resultList = `<div class="result-list-item">
            <div class="result-list-item__title">${title}</div>
              <div class="result-list-item__content">
              ${data
                .map((item) => {
                  return `<div data-type="product" class="result-list-item__content-item" onclick="window.location.href='${
                    item.handle
                  }'">
                ${this.highlightText(item.title, keyword)}</div>`;
                })
                .join('')}
              </div>
              </div>`;
          return resultList;
        }
        // 渲染说明书列表
        renderMunualList(data, element) {
          let keyword = '';
          if (window.innerWidth <= 1200) {
            keyword = this.mobileKeyword.trim();
          } else {
            keyword = this.keyword.trim();
          }
          const title = element.getAttribute('data-manual-name');
          const resultList = `<div class="result-list-item">
              <div class="result-list-item__title">${title}</div>
                <div class="result-list-item__content">
                ${data
                  .map((item) => {
                    return `<div data-type="product" class="result-list-item__content-item" onclick="window.location.href='/products/${
                      item.handle
                    }#manual'">
                      ${this.highlightText(item.title, keyword)}</div>`;
                  })
                  .join('')}
                </div>
                </div>`;
          return resultList;
        }
      }
    );
  }
});
